import {Injectable} from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import {Observable} from "rxjs";
import { HttpResponse } from "@angular/common/http";

import {NivelacionesService} from "../../nivelaciones/_services/nivelaciones.service";


@Injectable({
  providedIn: 'root'
})
export class NivelacionesCursoResolver  {

    constructor(private router: Router, private nivelacionesService: NivelacionesService) {
    }

    resolve(routeSnap: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any[]> {
        let id = routeSnap.paramMap.get('id'),
            idPeriodo = routeSnap.paramMap.get('idPeriodo') || 0;
        return this.nivelacionesService.getNivelacionesDirCurso(id, idPeriodo);
    }
}
